module.exports = __webpack_public_path__ + "59b4887aa5862cec6118e52467232ad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Straight Baguette@2x.png
// module id = 328
// module chunks = 0